/*
 * Member Sale 2026 — collection page price display
 * ---------------------------------------------------------------
 * Only runs on /collections/member-sale-2026 (loaded exclusively by
 * sections/member-sale-2026.liquid, via templates/collection.member-sale-2026.json).
 *
 * Rewrites the price shown on each product card *inside this one
 * collection's grid* to show the existing "on sale" style (struck-
 * through regular price + member price) plus a small "MEMBER -X%"
 * tag. It never changes prices, never touches other collections,
 * search results, recommendations, or the homepage, and never
 * touches checkout or discount logic — this is a visual overlay
 * only. The real discount is applied by PromoKIT at checkout.
 *
 * This file also marks, per product, that the shopper reached that
 * product by clicking through from THIS collection page — see the
 * "referral marker" section below. assets/member-sale-2026-product.js
 * reads that marker so the member price only shows on a product page
 * when the shopper actually arrived via /collections/member-sale-2026,
 * not when the same product is reached from any other collection,
 * search, or the homepage.
 *
 * TO REMOVE AFTER THE SALE: delete this file (see the removal
 * steps in sections/member-sale-2026.liquid).
 */
(function () {
  'use strict';

  var PROCESSED_ATTR = 'data-member-sale-applied';
  var REFERRAL_PREFIX = 'member-sale-2026:from:';

  // Records, in this tab's sessionStorage, that the shopper is about to
  // navigate to `path` by clicking through from this collection page.
  // assets/member-sale-2026-product.js checks for this marker before it
  // shows a member price on the product page — so the discount preview
  // only follows this specific click-through, not any other way of
  // reaching the same product.
  function markReferral(path) {
    try {
      sessionStorage.setItem(REFERRAL_PREFIX + path, '1');
    } catch (err) {
      // sessionStorage unavailable (e.g. some private-browsing modes) —
      // the product page also falls back to checking document.referrer.
    }
  }

  function escapeHtml(value) {
    var div = document.createElement('div');
    div.textContent = value == null ? '' : String(value);
    return div.innerHTML;
  }

  // Live-ticking countdown in the banner (data-member-sale-countdown).
  // Purely a client-side display: it reads the shopper's own device
  // clock against the end time set in the section settings, and never
  // touches price, discount, or checkout logic. When time runs out it
  // swaps the tiles for the "ended" message set in the section settings.
  function initCountdown() {
    var el = document.querySelector('[data-member-sale-countdown]');
    if (!el) {
      return;
    }

    var endTimeAttr = el.getAttribute('data-end-time');
    var endTime = endTimeAttr ? new Date(endTimeAttr) : null;
    if (!endTime || isNaN(endTime.getTime())) {
      console.error('[Member Sale 2026] Countdown end time is missing or invalid:', endTimeAttr);
      return;
    }

    var tiles = el.querySelector('[data-countdown-tiles]');
    var endedEl = el.querySelector('[data-countdown-ended]');
    var daysEl = el.querySelector('[data-countdown-days]');
    var hoursEl = el.querySelector('[data-countdown-hours]');
    var minutesEl = el.querySelector('[data-countdown-minutes]');
    var secondsEl = el.querySelector('[data-countdown-seconds]');
    var timer = null;

    function pad(number) {
      return number < 10 ? '0' + number : String(number);
    }

    function showEnded() {
      if (tiles) {
        tiles.hidden = true;
      }
      if (endedEl) {
        endedEl.hidden = false;
        endedEl.textContent = el.getAttribute('data-ended-text') || 'This offer has ended.';
      }
      if (timer) {
        window.clearInterval(timer);
      }
    }

    function render() {
      var remainingMs = endTime.getTime() - Date.now();

      if (remainingMs <= 0) {
        showEnded();
        return;
      }

      var totalSeconds = Math.floor(remainingMs / 1000);
      var days = Math.floor(totalSeconds / 86400);
      var hours = Math.floor((totalSeconds % 86400) / 3600);
      var minutes = Math.floor((totalSeconds % 3600) / 60);
      var seconds = totalSeconds % 60;

      if (daysEl) {
        daysEl.textContent = pad(days);
      }
      if (hoursEl) {
        hoursEl.textContent = pad(hours);
      }
      if (minutesEl) {
        minutesEl.textContent = pad(minutes);
      }
      if (secondsEl) {
        secondsEl.textContent = pad(seconds);
      }
    }

    render();
    timer = window.setInterval(render, 1000);
  }

  function applyToCard(card, entry, data) {
    var priceContainer = card.querySelector('[data-product-price]');
    if (!priceContainer) {
      return;
    }

    var priceSpan = priceContainer.querySelector('.price');
    if (!priceSpan) {
      // e.g. product shows "Sold out" instead of a price — leave untouched
      card.setAttribute(PROCESSED_ATTR, '1');
      return;
    }

    var fromPrefix = entry.varies
      ? '<small>' + escapeHtml(data.fromLabel) + '</small>'
      : '';

    priceSpan.classList.add('sale');
    priceSpan.innerHTML =
      '<span class="new-price">' + fromPrefix + escapeHtml(entry.member) + '</span>' +
      '<span class="old-price">' + escapeHtml(entry.regular) + '</span>';

    if (!priceContainer.querySelector('.member-sale-tag')) {
      var tag = document.createElement('span');
      tag.className = 'member-sale-tag';
      tag.textContent = (data.badgeLabel || 'MEMBER') + ' -' + entry.percent + '%';
      priceSpan.insertAdjacentElement('afterend', tag);
    }

    // Corner badge on the product image, reusing the theme's own
    // existing badge slot (the same container "sold out" / "new" /
    // "sale" badges already use), so it looks native there too.
    var badgeContainer = card.querySelector('.badge-box-container');
    if (badgeContainer && !badgeContainer.querySelector('.member-sale-corner-badge')) {
      var cornerBadge = document.createElement('span');
      cornerBadge.className = 'badge-box sale-box member-sale-corner-badge';
      cornerBadge.textContent = (data.badgeLabel || 'MEMBER') + ' -' + entry.percent + '%';
      badgeContainer.appendChild(cornerBadge);
    }

    card.setAttribute(PROCESSED_ATTR, '1');
  }

  function run(scope, byUrl, data) {
    var cards = scope.querySelectorAll('[data-url]:not([' + PROCESSED_ATTR + '])');
    cards.forEach(function (card) {
      var url = card.getAttribute('data-url');
      if (!url) {
        return;
      }
      url = url.split('?')[0];

      var entry = byUrl[url];
      if (!entry) {
        return;
      }

      applyToCard(card, entry, data);
    });
  }

  function init() {
    var dataEl = document.getElementById('member-sale-2026-pricing-data');
    if (!dataEl) {
      return;
    }

    var data;
    try {
      data = JSON.parse(dataEl.textContent);
    } catch (err) {
      console.error('[Member Sale 2026] Could not parse pricing data JSON.', err);
      return;
    }

    if (data.conflicts && data.conflicts.length) {
      data.conflicts.forEach(function (title) {
        console.warn(
          '[Member Sale 2026] "' + title + '" is in more than one discount-tier ' +
          'collection (member-sale-20 / -30 / -40). Showing its regular price ' +
          'until this is fixed — no discount tier was guessed.'
        );
      });
    }

    var byUrl = {};
    (data.products || []).forEach(function (entry) {
      byUrl[entry.url] = entry;
    });

    var scope = document.querySelector('.collection-member-sale-2026');
    if (!scope) {
      return;
    }

    // Initial pass over whatever is already rendered.
    run(scope, byUrl, data);

    // Mark, at click time, which product the shopper is navigating to
    // from this collection page — used by the product page to decide
    // whether to show the member price there. Listening on the scope
    // in the capture phase means this runs no matter which element
    // inside the card (image, title, etc.) was actually clicked, and
    // runs before the browser's normal navigation.
    scope.addEventListener('click', function (event) {
      var card = event.target.closest('[data-url]');
      if (!card) {
        return;
      }
      var url = card.getAttribute('data-url');
      if (!url) {
        return;
      }
      markReferral(url.split('?')[0].split('#')[0]);
    }, true);

    // The collection grid can be re-rendered client-side (sorting,
    // filtering, infinite scroll) without a full page reload. Re-apply
    // to any newly-added cards whenever that happens. The
    // data-member-sale-applied marker set in applyToCard() means our
    // own DOM changes never re-trigger themselves.
    var observer = new MutationObserver(function () {
      run(scope, byUrl, data);
    });
    observer.observe(scope, { childList: true, subtree: true });
  }

  function initAll() {
    init();
    initCountdown();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();